module.exports = "<h1 *ngIf=\"confirm?.title\" mat-dialog-title class=\"center\">{{confirm?.title}}</h1>\n\n<div mat-dialog-content class=\"content center\">\n  <div class=\"message\" [innerHTML]=\"confirm?.message\"></div>\n</div>\n\n<div mat-dialog-actions class=\"center\">\n  <button mat-raised-button [mat-dialog-close]=\"false\">No</button>\n  <button mat-raised-button color=\"accent\" [mat-dialog-close]=\"true\">Yes, I confirm</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/dialog-confirmation/dialog-confirmation.component.html
// module id = ./src/app/shared/dialog-confirmation/dialog-confirmation.component.html
// module chunks = main